import React from 'react';

import {
  SvgWrapper,
  SvgWrapperProps,
} from 'components/svgs/SvgWrapper/SvgWrapper';

interface ProductAccessOutlineSvgProps
  extends Omit<SvgWrapperProps, 'children'> {}

export const ProductAccessOutlineSvg = ({
  ...svgProps
}: ProductAccessOutlineSvgProps) => (
  <SvgWrapper viewBox="0 0 18 18" {...svgProps}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 1.08144C6 0.44424 6.58799 -0.0304368 7.21086 0.103925L15.2109 1.82962C15.6713 1.92894 16 2.33611 16 2.80714V15.18C16 15.6567 15.6635 16.0671 15.1961 16.1606L7.19612 17.7606C6.57733 17.8844 6 17.4111 6 16.78V1.08144ZM7 1.08144L15 2.80714V15.18L7 16.78V1.08144Z"
    />
    <path d="M3.5 1.99988C2.67157 1.99988 2 2.67145 2 3.49988V15.9999H3V3.49988C3 3.22374 3.22386 2.99988 3.5 2.99988H5V1.99988H3.5Z" />
  </SvgWrapper>
);
